<template>
  <div class="vertical-list-tabbed">
    <h2 class="mx-4 mb-4">{{ title }}</h2>
    <v-tabs v-model="tab" align-tabs="left">
      <v-tab
        :ripple="false"
        class="tab-flix ml-4"
        v-for="(t, i) in assets"
        :value="i"
        v-bind:key="i"
        >{{ t.title }}</v-tab
      >
    </v-tabs>
    <v-window v-model="tab">
      <v-window-item v-for="(t, n) in assets" :key="n" :value="n">
        <v-container fluid>
          <swiper
            :modules="modules"
            navigation
            :slides-per-view="slidesPerView"
            :space-between="20"
            :pagination="false"
            :scrollbar="false"
            @swiper="onSwiper"
            @slideChange="onSlideChange"
          >
            <swiper-slide
              v-for="(asset, i) in t.assets.filter((e) => e)"
              v-bind:key="i"
            >
              <vertical-card :type="type" :asset="asset" :position="i" />
            </swiper-slide>
          </swiper>
        </v-container>
      </v-window-item>
    </v-window>
  </div>
</template>

<script>
// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from "swiper/vue";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import VerticalCard from "@/components/landing/carousel/VerticalCard.vue";
import { A11y, Navigation, Pagination, Scrollbar } from "swiper";

export default {
  name: "TabbedVerticalCarousel",
  components: {
    VerticalCard,
    Swiper,
    SwiperSlide,
  },
  props: {
    assets: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: false,
      default: "",
    },
  },
  data: () => ({
    tab: null,
  }),
  computed: {
    slidesPerView() {
      if (this.isMobile()) {
        return 1.3;
      } else {
        return 4.3;
      }
    },
  },
  methods: {
    onSwiper(swiper) {},
    onSlideChange() {},
    onSwiperReachEnd(swiper) {},
  },
  setup() {
    return {
      modules: [Navigation, Pagination, Scrollbar, A11y],
    };
  },
};
</script>

<style lang="scss">
.v-tab--selected {
  .v-tab__slider {
    display: none !important;
    opacity: 0 !important;
  }
}

.tab-flix {
  &:after {
    content: none !important;
  }
  .v-btn__overlay {
    display: none !important;
    opacity: 0;
  }

  .v-btn__underlay {
    display: none !important;
  }
  &.v-btn {
    padding: 0 !important;

    background: linear-gradient(
      1.64deg,
      #202b40 -6.14%,
      rgba(12, 17, 26, 0) 160.73%
    );
    border: 1px solid #3f5782;
    &.v-btn--density-default {
      border-radius: 16px !important;
      height: 2.8em !important;
      padding: 0em 3em !important;
      margin: 0 1em;
    }

    &.v-slide-group-item--active {
      background: rgba(255, 255, 255, 0.18) !important;
    }
  }
}
</style>
